import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getVersion: () => {
		let url = `${BASE_URL}/guide/v1/versions`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getCategory: () => {
		let url = `${BASE_URL}/guide/v1/categories`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getDtlCategory: () => {
		let url = `${BASE_URL}/guide/v1/dtlCategories`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getGuideBoardList: ({ ver, category, dtlCategory, kwd, currentPage, pageUnit }) => {
		let url = `${BASE_URL}/guide/v1/guides?ver=${ver}&category=${category}&dtlCategory=${dtlCategory}&kwd=${kwd}&currentPage=${currentPage}&pageUnit=${pageUnit}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	addGuide: ({ formData }) => {
		let url = `${BASE_URL}/guide/v1/status/1/guides`;
		for (var pair of formData.entries()) {
			//console.log(pair[0] + ', ' + pair[1]);
		}
		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	saveGuide: ({ formData }) => {
		let url = `${BASE_URL}/guide/v1/status/2/guides`;
		for (var pair of formData.entries()) {
			//console.log(pair[0] + ', ' + pair[1]);
		}
		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	delGuide: ({ params }) => {
		let url = `${BASE_URL}/guide/v1/status/3/guides?boardNo=${params.boardNo}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fileDownload: ({ params }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/guide/v1/downloadFile`, params, { responseType: 'blob' })
				.then(response => {
					resolve(response);
				})
				.catch(error => reject(new Error(error.message || error.response)));
		});
	}
};
